module.exports = __webpack_public_path__ + "assets/img/web02.f9d3eb3c.png";